import React from 'react';
import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
  Legend
} from 'recharts';

const RiskAppetite = ({ height, risk_appetite }) => {
  // Prepare data with both target and real values
  const transformedData = risk_appetite?.map(({ category, target, real }) => ({

    category,
    target,
    real,
  }));

  return (
  <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={transformedData} margin={{ top: 60, right: 15, bottom: 0, left: 0 }}>
        <PolarGrid gridType="circle" />
        <PolarAngleAxis
    dataKey="category"
    tick={{ fontSize: 10, fill: '#555' }}
    tickLine={false}
  />        <PolarRadiusAxis />
        <Radar
          name="Target Appetite"
          dataKey="target"
          stroke="#0A4E62"
          fill="#0A4E62"
          fillOpacity={0.3}
        />
        <Radar
          name="Real Appetite"
          dataKey="real"
          stroke="#F07167"
          fill="#F07167"
          fillOpacity={0.3}
        />
        <Legend
          iconType="circle"           // keep your circle icons
          iconSize={10}               // ↓ default is 14 px – try 8-12 px
          wrapperStyle={{
            fontSize: 12,             // ↓ default is ~14 px
            lineHeight: '12px',       // tighten vertical spacing
            bottom: 10,              // pull the legend a bit closer
          }}
        />      
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default RiskAppetite;